import './index.css';

import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('app');
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
  <Auth0Provider
    domain="https://dev-80vc3us8.us.auth0.com"
    clientId="vLt7oqAvwpZv1aagumrtp8r8OTg1Y5np"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://api.blabberjax.com",
      scope: 'openid profile email offline_access'
    }}
    useRefreshTokens
    useRefreshTokensFallback={false}
    cacheLocation="localstorage"
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Auth0Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
